import React, { useEffect, useState, useRef } from "react";
import ReactToPrint from "react-to-print";
import { RouteNames } from "routes/routes";
import AppButton from "components/AppButton/AppButton";
import ContainerFlex from "components/ContainerFlex";
import CardsTab, {
  TipoCartao,
  OpcaoCartao,
} from "components/CardsTab/CardsTab";
import { useAppDispatch } from "redux/app/hooks";
import Endpoints from "services/api/endpoints";
import useApi, { ApiMethod } from "hooks/useApi";
import { LOCAL_STORE_CLIENTE } from "../../../constants";
import { getItemLocalStore } from "utils/storeUtils";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { showMessage } from "utils/messages";
import { isBlockedCard } from "utils/clientStatus";

import * as St from "./styles";
import { moneyMask } from "utils/mask";
import Checkbox from "components/checkbox";
import { TransacaoType } from "models/cliente";

const Extrato = () => {
  const dispatch = useAppDispatch();
  const componentRef = useRef<HTMLDivElement>(null);

  const [extrato, setExtrato] = useState<any>(null);
  const [saldoConvenio, setSaldoConvenio] = useState<any>(null);
  const [listaModalidade, setListaModalidade] = useState<any[]>([]);

  const dadosCliente = getItemLocalStore(LOCAL_STORE_CLIENTE);
  const { statusCliente, cartaoAtual, cartaoAtualConvenio, cpf, dadosLogin } =
    dadosCliente || {};

  const temCartaoTeucard = !!cartaoAtual;
  const temCartaoConvenio = !!cartaoAtualConvenio;
  const temTeucardCancelado = isBlockedCard(cartaoAtual?.status);
  const temValeCompras = temCartaoConvenio;

  const clienteApenasConvenio =
    (temTeucardCancelado || !temCartaoTeucard) && temCartaoConvenio;

  const [transacoes2, setTransacoes] = React.useState(
    [] as unknown as TransacaoType,
  );
  const [checked30, setChecked30] = React.useState(true);
  const [checked60, setChecked60] = React.useState(false);
  const [checked90, setChecked90] = React.useState(false);
  const [dias, setDias] = React.useState("30");

  const [cartaoAtivo, setCartaoAtivo] = useState<TipoCartao>(() => {
    if (clienteApenasConvenio) return "cartaoAtualConvenio";
    if (temCartaoTeucard) return "cartaoAtual";
    if (temCartaoConvenio) return "cartaoAtualConvenio";
    return "cartaoAtual";
  });

  const opcoesCartao: OpcaoCartao[] = [
    {
      value: "cartaoAtual",
      label: "TeuCard",
      disabled: !temCartaoTeucard || temTeucardCancelado,
    },
    {
      value: "cartaoAtualConvenio",
      label: "Convênio Multi",
      disabled: !temCartaoConvenio,
    },
    {
      value: "valeCompras",
      label: "Vale-compras",
      disabled: !temValeCompras,
    },
  ];

  const cartaoSelecionado =
    cartaoAtivo === "cartaoAtual" ? cartaoAtual : cartaoAtualConvenio;

  const numeroCartaoTeuCard = dadosLogin?.numeroCartaoTeucard;

  const getExtratoApi = useApi<any>(
    Endpoints.autorizador.postExtractConsolidate.replace("PARAM_DAYS", dias),
    ApiMethod.POST,
  );

  const getListaExtratosPorDiasApi = useApi<any>(
    Endpoints.autorizador.postListaExtratosPorDias
      .replace("PARAM_DIAS", dias)
      .replace("PARAM_LIMIT", String(0)),
    ApiMethod.POST,
  );

  const getSaldoCliente = useApi<any>(
    `${Endpoints.autorizador.getSaldoClienteByTokenCartao}?numeroCartao=${cartaoAtivo === "cartaoAtual" ? dadosLogin?.numeroCartaoTeucard : dadosLogin?.numeroCartaoConvenio}`,
    ApiMethod.GET,
  );

  const getExtratoCliente = async () => {
    if (!numeroCartaoTeuCard) {
      setExtrato(null);
      setTransacoes([] as unknown as TransacaoType);
      return;
    }

    dispatch(setLoading(true));
    dispatch(setTitleLoading("Carregando dados do seu extrato..."));

    const response = await getExtratoApi.callApi({
      numeroCartao: numeroCartaoTeuCard,
      limit: 0,
    });

    if (response.status >= 200 && response.status < 300) {
      setExtrato(response.data);
    } else {
      setExtrato(null);
      showMessage(
        "warning",
        "Atenção!",
        response?.data?.mensagem ||
          "Não foi possível carregar o extrato. Tente novamente.",
      );
    }

    dispatch(setLoading(false));
  };

  const getListaPorModalidade = async (
    origemLimite: "PADRAO" | "LIMITE_EXTRA",
  ) => {
    if (!dadosLogin?.numeroCartaoConvenio) {
      setListaModalidade([]);
      return;
    }

    dispatch(setLoading(true));
    dispatch(setTitleLoading("Carregando dados do seu extrato..."));

    const response = await getListaExtratosPorDiasApi.callApi({
      cpf,
      numeroCartao: dadosLogin.numeroCartaoConvenio,
      origemLimite,
      tipoCartao: "CONVENIO",
    });

    if (response.status >= 200 && response.status < 300) {
      setListaModalidade(Array.isArray(response.data) ? response.data : []);
    } else {
      setListaModalidade([]);
      showMessage(
        "warning",
        "Atenção!",
        response?.data?.mensagem ||
          "Não foi possível carregar o extrato. Tente novamente.",
      );
    }

    dispatch(setLoading(false));
  };

  const getSaldoConvenio = async () => {
    // if (!cartaoAtualConvenio?.numeroCartao) {
    //   setSaldoConvenio(null);
    //   return;
    // }

    try {
      const responseSaldo = await getSaldoCliente.callApi();

      if (responseSaldo.status >= 200 && responseSaldo.status < 300) {
        setSaldoConvenio(responseSaldo.data);
      } else {
        setSaldoConvenio(null);
      }
    } catch (error) {
      console.log(error);
      setSaldoConvenio(null);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("@TeuCard:LimiteExtrato", dias);

    if (cartaoAtivo === "cartaoAtual") {
      getSaldoConvenio();
      getExtratoCliente();
      return;
    }

    if (cartaoAtivo === "cartaoAtualConvenio") {
      getSaldoConvenio();
      getListaPorModalidade("PADRAO");
      return;
    }

    if (cartaoAtivo === "valeCompras") {
      getSaldoConvenio();
      getListaPorModalidade("LIMITE_EXTRA");
    }
    // getSaldoConvenio/getExtratoCliente/getListaPorModalidade vem de useApi/nao sao
    // memoizadas; incluir causaria refetch em loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartaoAtivo, dias]);

  useEffect(() => {
    try {
      if (extrato?.transacoes) {
        setTransacoes(extrato.transacoes as TransacaoType);
      } else {
        setTransacoes([] as unknown as TransacaoType);
      }
    } catch (error) {
      console.log(error);
      setTransacoes([] as unknown as TransacaoType);
    }
  }, [extrato]);

  const clickVoltar = () => {};

  const handleCheck = (idCheck: number, status: boolean) => {
    if (idCheck === 30) {
      setChecked30(status);
      setChecked60(false);
      setChecked90(false);
    } else if (idCheck === 60) {
      setChecked30(false);
      setChecked60(status);
      setChecked90(false);
    } else if (idCheck === 90) {
      setChecked30(false);
      setChecked60(false);
      setChecked90(status);
    }
    if (status) setDias(idCheck.toString());
  };

  const handleMudarCartao = (novoCartao: TipoCartao) => {
    setCartaoAtivo(novoCartao);
  };

  const valorTotal = (limiteCredito: number, saldo: number) =>
    limiteCredito - saldo;

  const renderListaTransacoesTeuCard = () => {
    const temTransacoes = (transacoes2 as any)?.[0]?.data?.length > 0;

    if (!temTransacoes) {
      return (
        <St.SpanTextValue>
          Nenhuma compra realizada no período escolhido
        </St.SpanTextValue>
      );
    }

    return (transacoes2 as any[]).map((compra: any) => (
      <ContainerFlex key={compra.dataTransacao}>
        <St.SpanTextTitleDataBold>
          {compra.dataTransacao}
        </St.SpanTextTitleDataBold>
        {(compra.data || []).map((transacao: any, index: number) => (
          <ContainerFlex row key={`${transacao.idTransacao || index}`}>
            <St.SpanTextValueTitle>
              {transacao.descricao || transacao.estabelecimento}
            </St.SpanTextValueTitle>
            <ContainerFlex end align="flex-end">
              {transacao.debitoCredito === "CREDITO" ||
              transacao.tipo === "PAGAMENTO_FATURA" ? (
                <St.SpanTextValue>
                  {`+ ${moneyMask(
                    Number(transacao.valorCompra ?? transacao.valor),
                  )}`}
                </St.SpanTextValue>
              ) : (
                <St.SpanTextValue>
                  {`- ${moneyMask(
                    Number(transacao.valorCompra ?? transacao.valor),
                  )}`}
                </St.SpanTextValue>
              )}
            </ContainerFlex>
          </ContainerFlex>
        ))}
      </ContainerFlex>
    ));
  };

  const gruposListaModalidade = () => {
    const mapa = new Map<string, any[]>();

    listaModalidade.forEach((item) => {
      const data = item.dataTransacao || "";
      if (!mapa.has(data)) mapa.set(data, []);
      mapa.get(data)!.push(item);
    });

    return Array.from(mapa.entries()).map(([data, itens]) => ({ data, itens }));
  };

  const limiteTotalModalidade =
    cartaoAtivo === "valeCompras"
      ? Number(saldoConvenio?.limiteCesta ?? 0)
      : Number(saldoConvenio?.limiteCartao ?? 0);

  const limiteDisponivelModalidade =
    cartaoAtivo === "valeCompras"
      ? Number(saldoConvenio?.limiteCestaDisponivel ?? 0)
      : Number(saldoConvenio?.saldo ?? 0);

  const labelDisponivel =
    cartaoAtivo === "valeCompras"
      ? "Limite total disponível saldo Vale-compras"
      : "Limite total disponível Convênio Multi";

  return (
    <ContainerFlex center>
      <St.TitleH1>Extrato</St.TitleH1>

      <ContainerFlex center style={{ marginBottom: 20 }}>
        <CardsTab
          opcoes={opcoesCartao}
          valorAtivo={cartaoAtivo}
          aoMudar={handleMudarCartao}
        />
      </ContainerFlex>

      <ContainerFlex padding={15} row>
        <div ref={componentRef} style={{ display: "contents" }}>
          <ContainerFlex
            padding={15}
            color="#fbfbfb"
            width={45}
            height={55}
            maxWidth={45}
            maxHeight={300}
            marginBottom={20}
            scroll
          >
            {cartaoAtivo === "cartaoAtual" ? (
              <>
                <St.SpanTextTitleBold>
                  Limite de Crédito R$
                </St.SpanTextTitleBold>
                <ContainerFlex row>
                  <St.SpanTextTitle>Limite total de crédito</St.SpanTextTitle>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {saldoConvenio && moneyMask(saldoConvenio?.limiteCartao)}
                    </St.SpanTextValue>
                  </ContainerFlex>
                </ContainerFlex>

                <St.Dividers />

                <St.SpanTextTitleBold>Compras Realizadas:</St.SpanTextTitleBold>
                {renderListaTransacoesTeuCard()}

                <St.Dividers />

                <ContainerFlex row>
                  <St.SpanTextTitleBold>Total:</St.SpanTextTitleBold>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {extrato &&
                        cartaoSelecionado &&
                        moneyMask(
                          valorTotal(
                            Number(saldoConvenio?.limiteCartao),
                            Number(extrato.saldo),
                          ),
                        )}
                    </St.SpanTextValue>
                  </ContainerFlex>
                </ContainerFlex>

                <St.Dividers />

                <ContainerFlex row>
                  <St.SpanTextTitleBold>
                    Limite disponível R$
                  </St.SpanTextTitleBold>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {extrato && moneyMask(Number(extrato.saldo))}
                    </St.SpanTextValue>
                    {statusCliente === "INADIMPLENTE" && (
                      <St.SpanTextValue
                        style={{ color: "red", fontSize: "12px" }}
                      >
                        Possui fatura em atraso
                      </St.SpanTextValue>
                    )}
                  </ContainerFlex>
                </ContainerFlex>
              </>
            ) : (
              <>
                <St.SpanTextTitleBold>Limite de crédito</St.SpanTextTitleBold>
                <ContainerFlex row>
                  <St.SpanTextTitle>Limite total de crédito</St.SpanTextTitle>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {moneyMask(limiteTotalModalidade)}
                    </St.SpanTextValue>
                  </ContainerFlex>
                </ContainerFlex>

                <St.Dividers />

                <ContainerFlex row>
                  <St.SpanTextTitleBold>
                    Compras Realizadas:
                  </St.SpanTextTitleBold>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextTitleBold>Total</St.SpanTextTitleBold>
                  </ContainerFlex>
                </ContainerFlex>

                {gruposListaModalidade().length === 0 ? (
                  <St.SpanTextValue>
                    Nenhuma compra realizada no período escolhido
                  </St.SpanTextValue>
                ) : (
                  gruposListaModalidade().map(({ data, itens }) => (
                    <ContainerFlex key={data}>
                      <St.SpanTextTitleDataBold>
                        {data}
                      </St.SpanTextTitleDataBold>
                      {itens.map((t) => {
                        const valorCompra = Number(t.valorCompra ?? 0);
                        const valorTransacao = Number(t.valorTransacao ?? 0);
                        const loja =
                          t.localTransacao || t.descricao || "Compra";

                        return (
                          <ContainerFlex key={t.idTransacao}>
                            <ContainerFlex row>
                              <St.SpanTextValueTitle>
                                <strong>{loja}</strong>
                              </St.SpanTextValueTitle>
                              <ContainerFlex end align="flex-end">
                                <St.SpanTextValue>
                                  {moneyMask(valorCompra)}
                                </St.SpanTextValue>
                              </ContainerFlex>
                            </ContainerFlex>
                            <ContainerFlex row>
                              <St.SpanTextValueTitle>
                                Valor utilizado nessa modalidade
                              </St.SpanTextValueTitle>
                              <ContainerFlex end align="flex-end">
                                <St.SpanTextValue>
                                  {moneyMask(valorTransacao)}
                                </St.SpanTextValue>
                              </ContainerFlex>
                            </ContainerFlex>
                          </ContainerFlex>
                        );
                      })}
                    </ContainerFlex>
                  ))
                )}

                <St.Dividers />

                <St.SpanTextTitleBold>Limite Disponível</St.SpanTextTitleBold>
                <ContainerFlex row>
                  <St.SpanTextTitle>{labelDisponivel}</St.SpanTextTitle>
                  <ContainerFlex end align="flex-end">
                    <St.SpanTextValue>
                      {moneyMask(limiteDisponivelModalidade)}
                    </St.SpanTextValue>
                  </ContainerFlex>
                </ContainerFlex>

                {statusCliente === "INADIMPLENTE" && (
                  <St.SpanTextValue style={{ color: "red", fontSize: "12px" }}>
                    Possui fatura em atraso
                  </St.SpanTextValue>
                )}
              </>
            )}
          </ContainerFlex>
        </div>
        <ContainerFlex padding={80} end center horizontal>
          <Checkbox
            message="30 dias"
            onChangeStatus={(status: boolean) => handleCheck(30, status)}
            value={checked30}
          />
          <Checkbox
            message="60 dias"
            onChangeStatus={(status: boolean) => handleCheck(60, status)}
            value={checked60}
          />
          <Checkbox
            message="90 dias"
            onChangeStatus={(status: boolean) => handleCheck(90, status)}
            value={checked90}
          />
        </ContainerFlex>
      </ContainerFlex>

      <ContainerFlex center horizontal row space>
        <AppButton
          content="Voltar"
          route={RouteNames.ATENDIMENTO_HOME}
          outlined={true}
          click={clickVoltar}
        />
        <ReactToPrint
          trigger={() => <button className="normal">Imprimir</button>}
          content={() => componentRef.current}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default Extrato;
